import { Link } from "react-router-dom";
import { gossipCategories, gossipList } from "@/mocks/gossipList";
import { formatHeat, statusClass } from "@/components/base/GossipCard";

export default function HotRankSection() {
  const top = [...gossipList].sort((a, b) => b.heat - a.heat).slice(0, 5);
  const maxHeat = top[0]?.heat ?? 1;

  return (
    <section id="hot" className="w-full bg-background-100 border-y border-background-200" aria-labelledby="hot-title">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-end justify-between gap-4 mb-6">
              <div>
                <p className="flex items-center gap-2 text-xs text-primary-600 mb-2">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-fire-line"></i>
                  </span>
                  TODAY RANKING
                </p>
                <h2 id="hot-title" className="font-heading font-black text-2xl md:text-3xl text-foreground-950">
                  今日热榜 TOP 5
                </h2>
              </div>
              <Link
                to="/rankings"
                className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer"
              >
                全部 30 条
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <ol className="space-y-3">
              {top.map((item) => (
                <li key={item.id}>
                  <Link
                    to={`/topic/${item.id}`}
                    className="group flex items-center gap-4 bg-background-50 border border-background-200 rounded-lg p-3 md:p-4 hover:border-primary-300 transition-colors cursor-pointer"
                  >
                    <span className="w-10 h-10 md:w-12 md:h-12 shrink-0 flex items-center justify-center rounded-md bg-primary-500 text-background-50 font-heading font-black text-lg md:text-xl">
                      {item.rank}
                    </span>
                    <div className="flex-1 min-w-0">
                      <h3 className="font-heading font-bold text-sm md:text-base text-foreground-950 leading-snug line-clamp-1 group-hover:text-primary-700 transition-colors">
                        {item.title}
                      </h3>
                      <div className="mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
                        <span className={`px-2 py-0.5 rounded-full border ${statusClass(item.status)}`}>{item.status}</span>
                        <span className="truncate max-w-[200px]">{item.people.join(" · ")}</span>
                        <span className="flex items-center gap-1 text-primary-600">
                          <i className="ri-fire-line"></i>
                          {formatHeat(item.heat)}
                        </span>
                      </div>
                      <div className="mt-2.5 h-1 w-full rounded-full bg-background-200 overflow-hidden">
                        <div
                          className="h-full rounded-full bg-gradient-to-r from-accent-400 to-primary-500"
                          style={{ width: `${Math.round((item.heat / maxHeat) * 100)}%` }}
                        ></div>
                      </div>
                    </div>
                  </Link>
                </li>
              ))}
            </ol>
          </div>

          <aside className="lg:col-span-1" aria-labelledby="cat-quick-title">
            <h2 id="cat-quick-title" className="font-heading font-black text-xl md:text-2xl text-foreground-950 mb-6">
              主题分类速览
            </h2>
            <div className="grid grid-cols-2 gap-3">
              {gossipCategories.slice(1).map((c) => {
                const count = gossipList.filter((g) => g.category === c.key).length;
                return (
                  <Link
                    key={c.key}
                    to={`/rankings?category=${encodeURIComponent(c.key)}`}
                    className="group flex flex-col gap-2 bg-background-50 border border-background-200 rounded-lg p-3.5 hover:border-accent-400 hover:bg-accent-50 transition-colors cursor-pointer"
                  >
                    <span className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700 group-hover:bg-accent-100 group-hover:text-accent-800 transition-colors">
                      <i className={`${c.icon} text-lg`}></i>
                    </span>
                    <span className="font-heading font-bold text-sm text-foreground-950">{c.label}</span>
                    <span className="text-xs text-foreground-500">{count} 条事件</span>
                  </Link>
                );
              })}
            </div>
            <div className="mt-4 bg-primary-900 rounded-lg p-5 text-primary-100">
              <p className="font-heading font-bold text-background-50 mb-2">怎么读这 30 条？</p>
              <p className="text-sm leading-relaxed text-primary-200">
                先看状态标签：持续发酵的适合追更，已澄清的可以当结论看，待回应的说明双方都还没开口。
              </p>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}